import React, { useState, useEffect } from 'react'
import Markdown from 'markdown-to-jsx'
import { Global } from '@emotion/core'
import { appPath } from '@fs/zion-config'
import axios from '@fs/zion-axios'
import { useTranslation } from 'react-i18next'
import { createMarkdownStyles } from '../../../../assets/markdownStyles'

const markdownStyles = createMarkdownStyles('type-thesaurus-markdown')

export default function PlaceReportsTypeThesaurus(): JSX.Element {
  const [t] = useTranslation()
  const [thesaurusContent, setThesaurusContent] = useState('')
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchThesaurus() {
      try {
        const response = await axios.get(`${appPath}/place-reports/markdown-content/?filename=type_thesaurus.md`)
        if (response.status === 200) {
          setThesaurusContent(response.data.content)
          setError(false)
        } else {
          setThesaurusContent('')
          setError(true)
        }
      } catch {
        // Silently fail and show error message to user
        setThesaurusContent('')
        setError(true)
      } finally {
        setLoading(false)
      }
    }
    fetchThesaurus()
  }, [])

  if (loading) {
    return (
      <>
        <Global styles={markdownStyles} />
        <div className="type-thesaurus-markdown">
          <p>{t('place-reports.type-thesaurus.loading.message', 'Loading...')}</p>
        </div>
      </>
    )
  }

  if (error) {
    return (
      <>
        <Global styles={markdownStyles} />
        <div className="type-thesaurus-markdown">
          <h1>{t('place-reports.type-thesaurus.error.header', 'Error')}</h1>
          <p>{t('place-reports.type-thesaurus.unable-to-load.message', 'Unable to load the type thesaurus.')}</p>
        </div>
      </>
    )
  }

  return (
    <>
      <Global styles={markdownStyles} />
      <div className="type-thesaurus-markdown">
        <Markdown>{thesaurusContent}</Markdown>
      </div>
    </>
  )
}
